import React from 'react'
import Eligibility_criteria_details_content from './Eligibility_criteria_details_content/Eligibility_criteria_details_content'

function Eligibility_criteria_details() {
  return (
    <section className="Terms_Conditions">        

        <Eligibility_criteria_details_content />
      </section>
  )
}

export default Eligibility_criteria_details